import { FC } from 'react'

export type ProposalTabKey = 'activas' | 'vencidas'

interface ProposalTabsProps {
  active: ProposalTabKey
  onChange: (tab: ProposalTabKey) => void
}

const TABS: { key: ProposalTabKey; label: string }[] = [
  { key: 'activas', label: 'ACTIVAS' },
  { key: 'vencidas', label: 'VENCIDAS' },
]

export const ProposalTabs: FC<ProposalTabsProps> = ({ active, onChange }) => {
  return (
    <div className="flex border-b border-olr-grey-2 mb-6">
      {TABS.map(tab => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`flex-1 px-4 py-3 text-xs font-semibold tracking-wide text-center border-b-2 transition-colors ${
            active === tab.key
              ? 'border-olr-primary text-olr-primary'
              : 'border-transparent text-olr-body hover:text-olr-dark'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
